var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expense.is_refund)?_c('Badge',{attrs:{"color":"danger"}},[_vm._v("Refund")]):_c('Badge',{attrs:{"color":"success"}},[_vm._v("Payment")])}
var staticRenderFns = []

export { render, staticRenderFns }